import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}blog/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                blogs: response.data.blogs,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'blog/get-by-id?id=' + id,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                blog: response.data.blog
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };

    }
}

//create a function to send the name and image to axios post to save the blogCategory
const Add = async (name, image, description, blogCategoryId) => {
    try {
        const data = new FormData();
        data.append("name", name);
        data.append("image", image);
        data.append("description", description);
        data.append("blogCategoryId", blogCategoryId);

        console.log("Image in service : " + image);

        console.log("Data in service : " + data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'blog/add', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("Blog added successfully");
            return {
                status: 200,
                message: response.data.message,
                blog: response.data.blog
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message

        };
    }
}

const Update = async (id, name, image, description, blogCategoryId, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("image", image);
        data.append("description", description);
        data.append("blogCategoryId", blogCategoryId);
        data.append("status", status);

        console.log("Image in service : " + image);

        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'blog/update', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                blog: response.data.blog
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}

//delete
const Delete = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.delete(`${config.apiUrl}blog/delete?id=${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}

//get latest blog
const GetLatestBlogs = async (count) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}blog/get-latest?count=${count}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            return {
                status: 200,
                blogs: response.data.blogs
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}


export { Add, Update, GetById, GetAll, Delete, GetLatestBlogs };

